import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button } from "@mui/material";
import DynamicTable from "../../../Components/Common/DynamicTable";
import EastIcon from "@mui/icons-material/East";
import { restructureData } from "../../../utils/restructureData";
import { validateOptionalTable } from "../../../utils/validateTable";
import { useNavigate, useParams } from "react-router-dom";
import { generateFiscalYearRanges } from "../../../utils/generateYearRanges";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import { get, put } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure24 = ({hide}) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "restatementsExplanation",
      title:
        "a. Report restatements of information made from previous reporting periods:",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "reportingPeriod",
          title: "Reporting Period",
          type: "select",
          options: generateFiscalYearRanges(5),
          width:"20%"
        },
        {
          fieldName: "reasonForRestatement",
          title: "Reason for Restatements",
          type: "text",
          placeholder: "Enter Text",
          width:"30%"

        },
        {
          fieldName: "effectOfRestatement",
          title: "Effects of Restatements",
          type: "text",
          placeholder: "Enter Text",
          width:"30%"

        },
      ],
    },
  ];

  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 = res?.data?.data?.GeneralDisclosures2021;
      setData(res1);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateOptionalTable(inputData, tables, setErrors)) return;

      let transformedData2 = {
        ...restructureData(tables),
        submitted2_4: true,
        type: "GeneralDisclosures2021",
      };
      console.log("abc", transformedData2);

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-5/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-5/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "2.5rem" }}>
        2-4 Restatements of information{" "}
      </p>
      <DynamicTable
        {...{
          inputData,
          tables,
          setTables,
          errors,
          disabled:  disabled ,
          setErrors,
          data,
          hide
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure24;
